class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    document.addEventListener('enavi:cart:build', (event) => {
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    document.dispatchEvent(new CustomEvent('enavi:write:engraving'));
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    return cart;
  }
  
  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    var cartBeforePromise = false;
    var lineDeleted = false;
    if (quantity == 0) {
        lineDeleted = true;
        cartBeforePromise = this.fetchCart();
    } else {
        cartBeforePromise = Promise.resolve(null);
    }

    cartBeforePromise.then(cartBefore => {


    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => Promise.all([response.clone().json(), response.text()]))
      .then(([jsonCart, state]) => { 
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        let cartNow = jsonCart;
        const allChildProducts = cartNow.items.every(item => item.properties && item.properties._child_product === true);
        document.dispatchEvent(new CustomEvent('enavi:cart:updated', {
          detail: {
            cart: cartNow,
            qty: quantity,
            lineDeleted: lineDeleted,
            cartBefore: cartBefore,
            line: line,
            allChildProducts: allChildProducts
          }
        }));

      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });

    }).catch(error => {
        console.error("Error fetching cart:", error);
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

/*======================
    Enavi Custom JS
=======================*/

window.theme = window.theme || {};

theme.EnaviCartForm = (function() {
  function EnaviCartForm(container) {
    this.init(container);
  };

  EnaviCartForm.prototype = Object.assign({}, EnaviCartForm.prototype, {
    init: function(container) {
      if(container){
        this.container = container;  
        this.timeZone = "America/Chicago";

        if(this.container.id == 'cart-page-form'){
          this.selectAll('.line-remove-btn').forEach(button => {
            button.addEventListener('click', this.handleRemoveBtn.bind(this));
          });
          this.cartUpdateBtn = this.container.querySelector('button.update-cart');
        };
        document.addEventListener('enavi:cart:updated', this.adjustChildQtyInDrawer.bind(this));
        document.addEventListener('enavi:cart:js-qty-updated', this.adjustChildQtyOnCartPage.bind(this));

        document.addEventListener('enavi:write:engraving', this.writeCheckoutShippingMessage.bind(this));
        this.writeCheckoutShippingMessage();
      }
    },  

    select: function(selector){
      return this.container.querySelector(selector);
    },

    selectAll: function(selector){
      return Array.prototype.slice.apply(this.container.querySelectorAll(selector));
    },

    adjustChildQtyOnCartPage: function(evt){
      const refKey = evt.detail.refKey;
      const productAddons = evt.detail.addons.split("|");
      if (evt.detail.qty == evt.detail.previousQty){
        return;
      }
      productAddons.forEach(addon => {
        if (addon != ""){
          this.selectAll('[data-child-title="'+addon+'"] .js-qty__num').forEach(input => {
            if (evt.detail.adjustAction == "plus"){
              input.value = parseInt(input.value)+1;
            }else if(evt.detail.adjustAction == "delete"){
              input.value = parseInt(input.value)-evt.detail.previousQty;
            }else{
              input.value = parseInt(input.value)-1;
            }
          });
        }
      });
      this.selectAll('[data-ref-parent-key="'+refKey+'"] .js-qty__num').forEach(input => {
        input.value = evt.detail.qty;
      });
    },

    adjustChildQtyInDrawer: function(evt) {
      window.cartBusy = true;

      try {
        const cart = evt.detail.cart;
        const cartBefore = evt.detail.cartBefore;

        const updateData = {};
        updateData.updates = {};

        if (evt.detail.lineDeleted == true && cartBefore != undefined) {
          var deletedItem = cartBefore.items[evt.detail.line - 1];
          if (deletedItem.properties && deletedItem.properties._parent_product) {
            var deleteChild = true;
            var qty = 0;
            this.setChildProductQty(cart, deletedItem, qty, updateData, deleteChild);
          };
        }

        var allParentItems = cart.items.filter(item => item.properties._parent_product);
        allParentItems.forEach(item => {
          var qty = item.quantity;
          this.setChildProductQty(cart, item, qty, updateData);
        });

        var params = {
          type: 'POST',
          url: '/cart/update.js',
          data: updateData,
          dataType: 'json',
          complete: () => {
            fetch('/cart', {
              method: 'GET'
            }).then(response => response.text())
              .then(cartPageHTML => {
                window.cartBusy = false;
                const config = [
                  {
                    selector: '#cart-icon-bubble',                   
                  },
                  {
                    selector: '#CartDrawer',
                    conditionClassTarget: 'parent',
                  },
                  {
                    selector: '#cart',
                    conditionClassTarget: 'parent',
                  },
                  {
                    selector: '#main-cart-footer .js-contents',
                    additionalSelector: '#main-cart-footer',
                    conditionClassTarget: 'additional',
                  }
                ];

                this.updateCartDisplay(cartPageHTML, evt, config);
                this.writeCheckoutShippingMessage();
                document.dispatchEvent(new CustomEvent('enavi:cart:build', {
                    detail: {
                        cart: cartPageHTML
                    }
                }));
              })
              .catch(error => {
                window.cartBusy = false;
                console.error("Error fetching cart page HTML:", error);
              });
          }
        };
        fetch(params.url, {
          method: params.type,
          body: JSON.stringify(params.data),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(params.complete);
      } catch (err) {
        window.cartBusy = false;
        console.error(err);
      }
    },
    
    updateCartDisplay: function(cartPageHTML, evt, config) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(cartPageHTML, 'text/html');

      config.forEach(item => {
        let extractedHTML = doc.querySelector(item.selector).innerHTML;
        document.querySelector(item.selector).innerHTML = extractedHTML;

        if (evt.detail.allChildProducts) {
          if (item.additionalSelector) {
            let additionalHTML = doc.querySelector(item.additionalSelector).innerHTML;
            document.querySelector(item.selector).innerHTML = additionalHTML;
          }
          if (item.conditionClassTarget === 'self') {
            document.querySelector(item.selector).classList.add('is-empty');
          } else if (item.conditionClassTarget === 'parent') {
            document.querySelector(item.selector).parentNode.classList.add('is-empty');
          } else if (item.conditionClassTarget === 'additional' && item.additionalSelector) {
            document.querySelector(item.additionalSelector).classList.add('is-empty');
          }
        }
      });
    },

    setChildProductQty: function (cart, item, qty, updateData, deleteChild){
      Object.entries(item.properties).map((function(property){
        if (!property[0].startsWith('_') && !property[0].startsWith('-')){
          var itemToUpdate = cart.items.filter(item => item.product_title == property[0] && item.properties._child_product);
          if(Object.keys(itemToUpdate).length != 0  ){
            var addonKey = itemToUpdate[0].key;
            if (deleteChild){
              updateData.updates[addonKey] =  0;
              return;
            }
            if (updateData.updates[addonKey]){
              updateData.updates[addonKey] =  updateData.updates[addonKey]+qty;
              
            }else{
              updateData.updates[addonKey] =  qty;
            }
          }
        }
      }))   
    },

    handleRemoveBtn: function(evt){
      var cartRow = evt.srcElement.closest('.cart__row');
      var refKey = cartRow.dataset.parentProduct;
      var parentAddons = cartRow.dataset.productAddons;
      var currentQty = cartRow.querySelector('.js-qty__num').value;
      var adjustAction = "delete";
      if(refKey){
        document.dispatchEvent(new CustomEvent('enavi:cart:js-qty-updated',{
          detail:{
            qty:0,
            previousQty:currentQty,
            refKey: refKey,
            addons: parentAddons,
            adjustAction: adjustAction
          }
        }));
        cartRow.querySelector('.js-qty__num').value = 0;
      }else{
        cartRow.querySelector('.js-qty__num').value = 0;
      }
      setTimeout((function(){
        this.cartUpdateBtn.click();
      }).bind(this),100);

    },

    writeCheckoutShippingMessage: function() {
      let currentDate = new Date(new Date().toLocaleString("en-US", {timeZone:  this.timeZone}));
      let customMessageContainer = document.querySelector('.custom-checkout-message');
      let pageCustomMessageContainer = document.querySelector('.page-custom-checkout-message');
      
      let date = {
        currentDay : currentDate.getDay(),
        currentHour : currentDate.getHours()
      };
      
      const setMessageContent = (container) => {
        if (document.querySelector('[data-clip-engraving]') !== null) {
          container.innerHTML = window.cartStrings.checkoutShippingMessageClipEngraving;
        } else {
          if (date.currentDay == 0 || date.currentDay == 6 || date.currentHour > 15 ) {
              container.innerHTML = window.cartStrings.checkoutShippingMessageTomorrow;
          } else {
              container.innerHTML = window.cartStrings.checkoutShippingMessageToday;
          }
        }
      };
      
      setMessageContent(customMessageContainer);  
      if (pageCustomMessageContainer) {
        setMessageContent(pageCustomMessageContainer);
      }
    }
  });

  return EnaviCartForm;
})();

new theme.EnaviCartForm(document.querySelector('#cart'));
new theme.EnaviCartForm(document.querySelector('.cart-drawer'));
